import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { createApiClient } from 'src/lib/api-client'

const updatePasswordChangedAt = async (): Promise<void> => {
  const res = await createApiClient({
    path: '/accounts/password_changed_at',
    httpMethod: 'put',
    params: {},
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }
}

export const useUpdatePasswordChangedAt = (
  option?: UseMutationOption<void, Error>,
) => {
  return useMutation(() => updatePasswordChangedAt(), option)
}
